import qs from 'qs';

import * as types from '../constants';
import api from '../api';

const setProducts = arr => dispatch =>
  dispatch({
    type: types.SET_PRODUCTS,
    payload: arr,
  });

const setProductsLoader = bool => dispatch =>
  dispatch({
    type: types.SET_PRODUCTS_LOADER,
    payload: bool,
  });

const setPage = num => dispatch =>
  dispatch({ type: types.SET_PAGE, payload: num });

const fetchFilters = obj => ({
  type: types.FETCH_FILTERS,
  payload: { filters: obj.filters, total: obj.total },
});

const setFiltersLoader = bool => dispatch =>
  dispatch({
    type: types.SET_FILTERS_LOADER,
    payload: bool,
  });

/*export const fetchFilters = () => async (dispatch, getState) => {
  try {
    dispatch(fetchFiltersStart());

    let location = getState().user.location;
    let params = {
      query: getState().catalog.searched,
      ...getState().catalog.selectedFilters,
      latitude: location ? location.latitude : null,
      longitude: location ? location.longitude : null,
    };
    let queryString = qs.stringify(params);
    let { data } = await api.get('filters', {
      params,
      paramsSerializer: () => queryString,
    });

    let filtered = {
      filters: {},
      total: data.total,
    };

    // eslint-disable-next-line array-callback-return
    Object.keys(data.filters).map(key => {
      if (data.filters[key].length > 1) {
        filtered.filters[key] = data.filters[key];
      }
    });
    dispatch(fetchFiltersSuccess(filtered));
  } catch (e) {
    console.error(e);
    dispatch(fetchFiltersError());
  }
};*/

export const setSelectedFilters = filters => dispatch =>
  dispatch({
    type: types.SET_SELECTED_FILTERS,
    payload: { filters },
  });

export const setFilter = ({ group, id }) => (dispatch, getState) => {
  let allSelected = getState().catalog.selectedFilters;
  let exist = allSelected?.[group] || [];

  if (exist.indexOf(id) >= 0) {
    allSelected = {
      ...allSelected,
      [group]: allSelected?.[group].filter(i => i !== id),
    };
  } else {
    allSelected = {
      ...allSelected,
      [group]: exist.concat([id]),
    };
  }

  dispatch({
    type: types.SET_FILTER,
    payload: allSelected,
  });
};

export const resetFilters = () => dispatch =>
  dispatch({
    type: types.RESET_FILTERS,
  });

export const fetchProducts = (nextPage = false) => async (
  dispatch,
  getState
) => {
  try {
    dispatch(setProductsLoader(true));
    dispatch(setFiltersLoader(true));
    let location = getState().user.location;
    let catalogState = getState().catalog;
    let {
      page,
      perPage,
      products,
      selectedFilters,
      searched,
      total,
    } = catalogState;

    if (nextPage) {
      if (page * perPage < total) {
        page++;
        dispatch(setPage(page));
      } else {
        return false;
      }
    } else {
      products = [];
    }

    let params = {
      page,
      perPage,
      query: searched,
      ...selectedFilters,
      latitude: location ? location.latitude : null,
      longitude: location ? location.longitude : null,
    };
    let queryString = qs.stringify(params);
    let { data } = await api.get('products', {
      params,
      paramsSerializer: () => queryString,
    });

    dispatch(
      fetchFilters({
        total: data.total,
        filters: data.filters,
      })
    );
    dispatch(setProducts([...products, ...data.data]));
    dispatch(setProductsLoader(false));
    dispatch(setFiltersLoader(false));
  } catch (e) {
    console.error(e);
    dispatch(setProductsLoader(false));
    dispatch(setProducts([]));
  }
};

export const setSearchQuery = payload => dispatch => {
  dispatch(setProducts([]));
  dispatch({
    type: types.SET_SEARCH_QUERY,
    payload,
  });
};
